<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <router-link
          class="btn btn-primary"
          :to="{ name: 'campaignsapp.create' }"
          ><i class="fa fa-plus"></i> Criar</router-link
        >
        <exporter
          grid-ref="campaignResultsGrid"
          :url="'campaignsresults/exportresultscampaigns'"
        ></exporter>
      </div>

      <Grid
        ref="campaignResultsGrid"
        name="campaignsappGrid"
        v-bind:url="url"
        v-bind:preload="preload"
        v-bind:columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        v-bind:schemaModelFields="schemaModelFields"
        :default-filter="defaultFilter"
      ></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import lists from "@/components/States.js";

export default {
  name: "campaignsappGrid",
  components: {
    Grid,
  },
  data() {
    return {
      schemaModelFields: {
        state: {
          type: "number",
        },
        ym_start: {
          type: "string",
        },
        ym_end: {
          type: "string",
        },
      },
      defaultFilter: {
      logic: 'and',
      filters: [
        {
          field: 'state',
          operator: 'eq',
          value: 1
        }
      ]
    },
      preload: [
        {
          field: "prodaggreg_id",
          api: "prodaggregs/lst",
        },
      ],
      url: "campaignsapp",
      columns: [
        {
          template: this.getBtnTemplate,
          title: "",
          width: "100px",
        },
        {
          field: "id",
          title: "Id",
          width: "100px",
        },
        {
          field: "description",
          title: "Descrição",
          width: "220px",
        },
        {
          field: "state",
          title: "Estado",
          values: lists.states,
          width: "100px",
        },
        {
          field: "ym_start",
          title: "Inicio",
          width: "100px",
        },
        {
          field: "ym_end",
          title: "Fim",
          width: "100px",
        },
        {
          field: "success_margin",
          title: "% Sucesso",
          width: "100px",
        },
        {
          field: "type",
          title: "Tipo",
          width: "100px",
        },
        {
          field: "dealer_id",
          title: "Dist.",
          width: "100px",
        },
        {
          field: "dealer_name",
          title: "Distribuidor",
          width: "220px",
        },
        {
          field: "zone",
          title: "Zona",
          width: "100px",
        },
        {
          field: "target",
          title: "Objectivo",
          width: "100px",
          filterable: false,
        },
        {
          field: "real",
          title: "Real",
          width: "100px",
          filterable: false,
        },
        {
          field: "success",
          title: "Sucesso",
          width: "100px",
        },
      ],
    };
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "bestof.edit",
        params: {
          id: item.id,
        },
      });
      if (this.$auth.check("bestof.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
        );
      }
      return "";
    },
    exportGrid() {
      this.exporting = true;
      const grid = this.$refs.campaignResultsGrid.$refs.mygrid.kendoWidget();
      const filters = grid.getOptions().dataSource.filter;

      this.axios
        .post("campaignsresults/exportresultscampaigns", { filter: filters })
        .then((response) => {
          if (response.data && response.data.url) {
            window.open(response.data.url, "_blank");
          } else {
            this.$bvToast.toast("Falha ao gerar o arquivo.", {
              variant: "danger",
              solid: true,
            });
          }
          this.exporting = false;
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Houve um erro ao exportar", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.exporting = false;
        });
    },
  },
};
</script>
